import { PropsWithChildren, useCallback, useState } from 'react';
import { FilterContext } from './filter-context';
import { useStoredState } from '../hooks';
import { FilterContextValue } from './types';

const hideClosedTasksStorageKey = 'hideClosedTasks';

const FilterContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [hideClosedTasks, setHideClosedTasks] = useStoredState(hideClosedTasksStorageKey, false);
  const [showAllApps, setShowAllApps] = useState(false);

  const toggleClosedTasks = useCallback(() => {
    setHideClosedTasks((value) => !value);
  }, [setHideClosedTasks]);

  const toggleAllApps = useCallback(() => {
    setShowAllApps((value) => !value);
  }, [setShowAllApps]);

  const value: FilterContextValue = {
    hideClosedTasks,
    showAllApps,
    toggleClosedTasks,
    toggleAllApps,
  };

  return <FilterContext value={value}>{children}</FilterContext>;
};

export default FilterContextProvider;
